import { render, staticRenderFns } from "./SearchProductsToolbar.vue?vue&type=template&id=0b2cd620&scoped=true&"
import script from "./SearchProductsToolbar.vue?vue&type=script&lang=js&"
export * from "./SearchProductsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductsToolbar.vue?vue&type=style&index=0&id=0b2cd620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2cd620",
  null
  
)

export default component.exports